import { render, staticRenderFns } from "./AttachmentTypeEdit.vue?vue&type=template&id=b3454fe2&"
import script from "./AttachmentTypeEdit.js?vue&type=script&lang=js&"
export * from "./AttachmentTypeEdit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports